<template>
    <div style="padding-top: -50px;">
        <b-row>
            <div class="pt--2 w-100">
                <h4>Altere a quantidade de ingressos para esta reserva.</h4>

                <small class="pt-1 text-danger">
                    {{ hasPassedMaxValue ? "* Valor máximo de ingressos ultrapassado: " +
                        (new Number(oldTotalCost)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) :
                        "Valor máximo: " + (new Number(oldTotalCost)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
                    }}
                </small>
            </div>

            <div v-if="atrativo.special_prices != undefined && atrativo.special_prices != undefined" class="ticketinfoarea">
                <div class="pl-2">
                    <b-row v-for="(ticket, idx) in form.tickets" :key="idx" class="mb-2 pb-0">
                        <b-col v-if="!ticket.blocked" cols="10" class="ticketselectarea">
                            <h4 class="mb-0">
                                {{ ticket.label + ' (' + 'R$' + Number(ticket.price).toFixed(2).replace('.', ',') + ')' }}
                            </h4>

                            <div class="mb-2" style="line-height: 1;">
                                <small style="font-size: 70%; ">
                                    {{ ticket.label_description.length > 0 ? ticket.label_description + " " : "" }}
                                    <br>
                                    {{ ticket.min.length > 0 && ticket.min != "0" ? "Min: " + ticket.min : "" }}
                                    {{ ticket.max.length > 0 && ticket.max != "0" ? "Max: " + ticket.max : "" }}
                                </small>
                            </div>
                        </b-col>

                        <b-col cols="2" style="min-width: 2rem;">
                            <div class="ml-auto mr-3" style="min-width: 6rem;">
                                <b-row>
                                    <div>
                                        <b-button @click="decreaseTicketQuantity(idx)" :disabled="disableMinusTicket(idx)" pill variant="success" size="sm"
                                            style="padding: 0.20rem 0.50rem;" class="rounded">
                                            <i style="font-size: 10px;" class="fas fa-minus"></i>
                                        </b-button>
                                    </div>

                                    <div class="pt-1 mr-2 ml-2">
                                        <h5>{{ ticket.quantity }}</h5>
                                    </div>

                                    <div>
                                        <b-button @click="increaseTicketQuantity(idx)" :disabled="disablePlusTicket(idx)" pill variant="success" size="sm"
                                            style="padding: 0.20rem 0.50rem;" class="rounded">
                                            <i style="font-size: 10px;" class="fas fa-plus"></i>
                                        </b-button>
                                    </div>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-row>

        <hr style="margin-top: 1.5%; margin-bottom: 1.5%;">

        <b-row>
            <b-col class="text-left" cols="4">
                <h5>Valor Antigo</h5>
                <h4>{{ (new Number(oldTotalCost)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</h4>
            </b-col>

            <b-col class="text-left" cols="4">
                <h5>Valor Atual</h5>
                <h4>{{ (new Number(currentTotalCost)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</h4>
            </b-col>

            <b-col class="text-left" cols="4">
                <h5>Valor a ser reembolsado</h5>
                <h4>{{ oldTotalCost - currentTotalCost >= 0 ?
                        (new Number(oldTotalCost - currentTotalCost)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) :
                        (new Number(0)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
                    }}
                </h4>
            </b-col>
        </b-row>

        <b-row style="margin-top: 2%;" align-v="center">
            <b-col cols="6" class="d-flex mt-2" align-h="start">
                <b-form-group label="Reembolso">
                    <b-form-radio-group v-model="form.pixRefund" :options="refundOptions" stacked :rules="{ required: true }"
                        value-field="value" text-field="label">
                    </b-form-radio-group>
                </b-form-group>
            </b-col>

            <b-col v-if="form.pixRefund == 'pix'" cols="6">
                <b-form-group label="Chave Pix" label-class="small">
                    <b-form-input v-model="form.pix" placeholder="Insira a chave Pix"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row align-v="center" class="pt-3">
            <b-col cols="12">
                <b-form-group label="Observações" label-class="small">
                    <b-form-input v-model="form.message" placeholder="Insira a observações sobre a alteração"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <template span="modal-footer">
                <div class="w-100 pt-6 pr-2 text-right">
                    <b-button @click="closeModal()" variant="secondary">Cancelar</b-button>
                    <b-button @click="confirmTicketsChange()" :disabled="disabledSaveButton()" variant="primary">Salvar</b-button>
                </div>
            </template>
        </b-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import swal from "sweetalert2"
import useManageReservaExpressaInjection from "../../Composables/useManageReservaExpressa"

export default {
    name: 'ChangeBookingTickets',

    setup(props, context) {
        const manageReservaExpressa = useManageReservaExpressaInjection(context)

        function calculateTotalCost() { return manageReservaExpressa.calculateTotalCost() }
        function setTickets(items) { return manageReservaExpressa.setTickets(items) }
        function setSelectedSpecialBookingType(item) { return manageReservaExpressa.setSelectedSpecialBookingType(item) }

        return {
            calculateTotalCost, setTickets, setSelectedSpecialBookingType
        }
    },

    components: {
    },

    props: {
        bookingDetails: {
            type: Object,
            default: () => ({}),
        },

        showBookingTicketModal: {
            type: Boolean,
            default: () => (true),
        },

        PLACE_UUID: {
            type: String,
            default: () => (""),
        },

        PRODUCT_UUID: {
            type: String,
            default: () => (""),
        },
    },

    watch: {
        ['form.tickets']: {
            immediate: true, deep: true,
            handler: function(newValue, oldValue){
                if(newValue.length > 0){
                    this.setTickets(newValue)
                    this.checkPixRefund()
                }
            },
        },

        currentOldDiff(newValue, oldValue){
            if(newValue == 0){
                this.form.pixRefund = 'no_refund'
                this.refundOptions[0].disabled = false
                this.refundOptions[1].disabled = true
                this.refundOptions[2].disabled = true
            }
            if(newValue > 0){
                this.form.pixRefund = 'pix'
                this.refundOptions[0].disabled = true
                this.refundOptions[1].disabled = false
                this.refundOptions[2].disabled = false
            }
        },

    },

    computed: {
        ...mapGetters('product', {
            poisList: 'getPois',
        }),

        currentTotalCost() { return this.calculateTotalCost() },

        oldTotalCost(){
            var vm = this

            return this.bookingDetails.payload.items.map(function(val, idx){
                var quantity = Number(val.quantity)
                var price = val.unit_price != undefined ? parseFloat(`${val.unit_price}`.replace(/[^0-9.]/g, ".")) : vm.atrativo.price
                var final_value = 0.0

                if(quantity > 0){ final_value = (price * quantity) }

                return final_value
            }).filter(i => i != undefined).reduce((prev, cur) => { return prev + cur }, 0.0)
        },

        atrativo() {
            const poiIndex = this.poisList.findIndex(p => p.uuid == this.PRODUCT_UUID)
            if (poiIndex >= 0) { return this.poisList[poiIndex] }
            return {}
        },

        maxTicketsAmount() { return this.bookingDetails.payload.items.map(t => t.quantity).reduce((prev, curr) => prev + curr, 0) },

        hasPassedMaxValue() { return this.currentTotalCost > this.oldTotalCost },

        currentOldDiff(){ return (this.currentTotalCost - this.oldTotalCost) },
    },

    data() {
        return {
            form: { pixRefund: false, tickets: [], message: "", pix: "", booking_code: "", },
            refundOptions: [
                { label: 'Sem Reembolso', value: 'no_refund', disabled: false }, { label: 'Carteira', value: 'wallet', disabled: false },
                { label: 'Pix', value: 'pix', disabled: false },
            ]
        }
    },

    methods: {
        ...mapActions('product', [
            'fetchPOIs',
        ]),

        ...mapActions('agent', [
            "updateExpressBookingTickets",
        ]),

        closeModal() { this.$emit("emitCloseBookingTicketsModal") },

        formatTicketValues(ticket) {
            const price = Number(ticket.price.replace(',', '.'))
            const quantity = Number(ticket.quantity)
            return 'R$ ' + (price * quantity).toFixed(2).replace('.', ',')
        },

        checkFreeBooking() {
            var totalQuantity = this.form.tickets.reduce((prev, curr) => prev + curr.quantity, 0)
            if (this.currentTotalCost == 0 && totalQuantity > 0) {
              this.form.tickets.free_booking = true
            }
            else {
              this.form.tickets.free_booking = false
            }
        },

        increaseTicketQuantity(idx) {
            if (this.form.tickets[idx].max != undefined && this.form.tickets[idx].max != null) {
                const max = Number(this.form.tickets[idx].max)
                if (this.form.tickets[idx].quantity < max) {
                    this.form.tickets[idx].quantity = (new Number(this.form.tickets[idx].quantity)) + 1
                }
            }
            else {
                this.form.tickets[idx].quantity = (new Number(this.form.tickets[idx].quantity)) + 1
            }

            this.checkFreeBooking()
        },

        decreaseTicketQuantity(idx) {
            if (this.form.tickets[idx].min != undefined && this.form.tickets[idx].min != null) {
                const min = Number(this.form.tickets[idx].min)
                if (this.form.tickets[idx].quantity > min) {
                    this.form.tickets[idx].quantity = (new Number(this.form.tickets[idx].quantity)) - 1
                }
            }

            else {
                if (this.form.tickets[idx].quantity > 0) {
                    this.form.tickets[idx].quantity = (new Number(this.form.tickets[idx].quantity)) - 1
                }
            }

            this.checkFreeBooking()
        },

        disablePlusTicket(idx) {
            const ticketPrice = Number(this.form.tickets[idx].price.replace(',', '.'))

            if (this.hasPassedMaxValue || (ticketPrice + this.currentTotalCost > this.oldTotalCost) ||
                (this.form.tickets[idx].max != undefined && this.form.tickets[idx].quantity >= Number(this.form.tickets[idx].max))) {
                    return true;
            }
            return false;
        },

        disableMinusTicket(idx) {
            if (this.form.tickets[idx].min != undefined && this.form.tickets[idx].quantity <= Number(this.form.tickets[idx].min)) { return true; }
            if (this.form.tickets[idx].min == undefined && this.form.tickets[idx].quantity <= 0) { return true; }
            return false;
        },

        disabledSaveButton() {
            var totalQuantity = this.form.tickets.reduce((prev, curr) => prev + curr.quantity, 0)
            if ((this.form.tickets.length == 0) || this.hasPassedMaxValue || totalQuantity == 0 || (this.form.pixRefund == 'pix' && this.form.pix.length == 0) ) { return true }
            else { return false }
        },

        checkPixRefund(){
            if(this.currentOldDiff == 0){
              this.form.pixRefund = 'no_refund'
              this.refundOptions[0].disabled = false
              this.refundOptions[1].disabled = true
              this.refundOptions[2].disabled = true
            }
            else if(this.currentOldDiff < 0){
              this.refundOptions[0].disabled = true

              if(this.bookingDetails.channel.toUpperCase().indexOf('LARAVEL') >= 0 || this.bookingDetails.channel.toUpperCase() == 'STRIPE'){
                this.refundOptions[1].disabled = false
                this.refundOptions[2].disabled = false
                  if(this.form.pixRefund == 'no_refund'){
                    this.form.pixRefund = 'wallet'
                  }
              }
              else  if(this.bookingDetails.channel.toUpperCase() == 'RESERVAEXPRESSA' || this.bookingDetails.channel.toUpperCase() == 'POSCONTROLE'){
                  this.form.pixRefund = 'pix'
                  this.refundOptions[1].disabled = true
                  this.refundOptions[2].disabled = false
              }
            }
        },

        setInitialTickets() {
            var vm = this
            var bookingTickets = JSON.parse(JSON.stringify(this.bookingDetails.payload.items))
            var items = Object.values(JSON.parse(JSON.stringify(this.atrativo.tickets)))

            this.form.tickets = items.map(function (item, index) {

                if (item.price == "default") { item.price = `${vm.atrativo.price}` }
                if (item.max == "default") { item.max = vm.atrativo.special_prices[0][0].max_persons }

                const ticketIndex = bookingTickets.findIndex(t => Number(t.unit_price) == Number(item.price))

                if (ticketIndex >= 0) { item.quantity = bookingTickets[ticketIndex].quantity }
                else { item.quantity = 0 }

                return item
            })

            this.setTickets(this.form.tickets)
        },

        confirmTicketsChange() {
            swal.fire({
                text: "Confirmar alteração de ingressos?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Alterar',
                confirmButtonColor: '#12576e',
                cancelButtonText: 'Cancelar',
                cancelButtonColor: 'secondary',
                reverseButtons: true,
                type: 'default'
            }).then((result => {
                if (result.isConfirmed) {
                  this.$emit("setIsLoading", true)
                  this.updateExpressBookingTickets(this.form)
                    .then(() => {
                      this.$emit("bookingTicketsUpdated")
                    })
                    .catch((error) => {
                      // nodeApi3 rejeita com o response; a mensagem da API vem em data
                      const apiMessage = error && error.data && error.data.message
                      console.error('alterar os ingressos da reserva failed', { hash: this.bookingDetails && this.bookingDetails.hash, error })
                      this.$emit("setIsLoading", false)
                      swal.fire({
                        text: apiMessage
                          ? `Não foi possível alterar os ingressos da reserva: ${apiMessage}`
                          : "Não foi possível alterar os ingressos da reserva.",
                        icon: 'error',
                        confirmButtonText: 'Fechar',
                        confirmButtonColor: '#D93051',
                      })
                    })
                }
              }))
        },

        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);

                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },

        handleBackDateChange() {
            if (this.showDateChangeModal) {
                this.closeModal()
                return
            }
            else {
                this.$router.back()
                return
            }
        },
    },

    async mounted() {
        await this.fetchPOIs({ PLACE_UUID: this.PLACE_UUID, PRODUCT_UUID: this.PRODUCT_UUID })
        this.setSelectedSpecialBookingType({});
        this.setInitialTickets()
        this.checkPixRefund()
        this.checkFreeBooking()

        this.form.hash = this.bookingDetails.bookingCode
    },

    created() { window.addEventListener("popstate", this.handleBackDateChange); },
    beforeDestroy() { window.removeEventListener("popstate", this.handleBackDateChange); },

}
</script>

<style>
.insidereservainfo {
    width: 350px;
    height: auto;
    background: #F9F9F9;
    border: 1px solid #DBDBDB;
    border-radius: 12px;
    padding: 10px;
    margin-top: 10px
}

.floating-total {
    width: 400px;
    height: auto;
    background: #ffffff;
    border: 1px solid #DBDBDB;
    border-radius: 12px 12px 0 0px;
    padding: 15px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    left: 50%;
    justify-content: space-between;
    transform: translateX(-50%);
}

.ticketinfoarea {
    /* width: 85%; */
    margin-top: 20px;
}

.selectarea {
    width: 85%;
}

.ticketselectarea {
    width: 75%;
}


@media screen and (max-width: 980px) {

    .floating-total {
        width: 400px;
        height: auto;
        background: #ffffff;
        border: 1px solid #DBDBDB;
        border-radius: 12px 12px 0 0px;
        padding: 15px;
        z-index: 999;
        position: fixed;
        bottom: 0;
        left: 38%;
        justify-content: space-between;
        transform: translateX(-50%);
    }

}

@media screen and (max-width: 870px) {
    .ticketinfoarea {
        width: 100%;
        margin-top: 20px;
    }

    .selectarea {
        width: 100%;
    }

    .ticketselectarea {
        width: 65%;
    }

    .floating-total {
        width: 100%;
        height: auto;
        background: #ffffff;
        border: 1px solid #DBDBDB;
        padding: 15px;
        z-index: 999;
        position: fixed;
        bottom: 0;
        left: 50%;
        padding-bottom: 25px;
        justify-content: space-between;
        transform: translateX(-50%);
    }

    .ticketinfoarea {
        margin-top: 15px
    }
}
</style>
